import { Button } from "@portal/BaseComponents/Button/AntButton";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { Invoice } from "@portal/types/entities/invoice";
import { ActivitiesActionButtonProps } from "../type";
import { PTPModal } from "./PTPForm/Modal/PTPModal";

const t = {
  title: "Promise to Pay",
};

interface PromiseToPayProps extends ActivitiesActionButtonProps {
  defaultInvoice?: Invoice[];
}

function PromiseToPay(props: PromiseToPayProps) {
  const {
    title = t.title,
    buttonProps,
    iconOnly,
    showToolTip,
    onOpenChange,
    defaultInvoice,
    open: defaultOpen,
    loading,
  } = props;

  const { open, onClose, toggleOpen } = useOpen({
    open: defaultOpen ? defaultOpen : false,
  });

  function handleClose() {
    onClose();
    props.onclose?.();
  }
  const PTPIcon = <Icon icon={["far", "handshake-simple"]} />;
  const Modal = (
    <PTPModal
      open={open}
      onClose={handleClose}
      onOpenChange={onOpenChange}
      loading={loading}
      defaultInvoice={defaultInvoice}
    />
  );

  return (
    <>
      <ToolTip open={showToolTip ? undefined : false} title={t.title}>
        <Button icon={PTPIcon} {...buttonProps} onClick={toggleOpen}>
          {iconOnly ? null : title}
        </Button>
      </ToolTip>
      {open && Modal}
    </>
  );
}

export { PromiseToPay };
